import React from 'react'
import Banner from '../components/modude/Banner'
import FullGallery from '../components/modude/FullGallery'

const Albums = () => {
  return (
    <div>
      <Banner />
      <FullGallery />
    </div>
  )
}

export default Albums